/**
 * Storage that never throws when the document is sandboxed, in private
 * mode, or otherwise blocked from window.localStorage.
 */

export type StorageLike = Pick<Storage, "getItem" | "setItem" | "removeItem">;

class MemoryStorage implements StorageLike {
  private data = new Map<string, string>();
  getItem(key: string): string | null {
    return this.data.get(key) ?? null;
  }
  setItem(key: string, value: string): void {
    this.data.set(key, value);
  }
  removeItem(key: string): void {
    this.data.delete(key);
  }
}

let memory: MemoryStorage | null = null;

export function safeStorage(): StorageLike {
  try {
    const storage = window.localStorage;
    storage.getItem("__granrojo_probe");
    return storage;
  } catch {
    memory ??= new MemoryStorage();
    return memory;
  }
}
